'use strict';

angular.module('eva2-angular')
  .filter('hasCurrentAssignment', function($stateParams) {
    return function() {
      return ($stateParams && $stateParams.domain) ? true : false;
    };
  });
